import { invertObj } from 'ramda';
import { colorPalettes } from 'lego-dist';

const { KineduPalette } = colorPalettes;
export const Areas = {
  PHYSICAL: 1,
  COGNITIVE: 2,
  LINGUISTIC: 3,
  SOCIAL_EMOTIONAL: 4,
  HEALTH: 5,
};

export const AreaNamesById = {
  [Areas.PHYSICAL]: 'Physical',
  [Areas.COGNITIVE]: 'Cognitive',
  [Areas.LINGUISTIC]: 'Linguistic',
  [Areas.SOCIAL_EMOTIONAL]: 'Social emotional',
  [Areas.HEALTH]: 'Health',
};

export const InvertAreaNameById = invertObj(Areas);

export const AreaDetail = [
  {},
  {
    name: 'PHYSICAL',
    icon: 'physical',
    color: KineduPalette.physical,
  },
  {
    name: 'COGNITIVE',
    icon: 'cognitive',
    color: KineduPalette.cognitive,
  },
  {
    name: 'LINGUISTIC',
    icon: 'linguistic',
    color: KineduPalette.linguistic,
  },
  {
    name: 'SOCIAL_EMOTIONAL',
    icon: 'socialEmotional',
    color: KineduPalette.socialEmotional,
  },
  {
    name: 'HEALTH',
    icon: 'health',
    color: KineduPalette.health,
  },
  {
    type: 'webinar_session',
    name: 'WEBINAR',
    icon: 'webinar',
    color: KineduPalette.webinar,
  },
  {
    type: 'interactive_session',
    name: 'INTERACTIVE',
    icon: 'interactiveSession',
    color: KineduPalette.interactive,
  },
];
